// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1z1qQ","notes":"Notes_notes__1l09N","note":"Notes_note__31Zox","markdown":"Notes_markdown__3yIdF"};